/**
 * Joyee Banner Carousel
 * Crossfade slideshow with autoplay, dot navigation, touch swipe, and progress ring.
 */
(function() {
  document.querySelectorAll('[data-joyee-carousel]').forEach(function(section) {
    var track  = section.querySelector('[data-joyee-carousel-track]');
    var slides = [].slice.call(section.querySelectorAll('[data-joyee-carousel-slide]'));
    var dots   = [].slice.call(section.querySelectorAll('[data-joyee-carousel-dot]'));
    if (!track || slides.length <= 1) return;

    var autoplaySpeed      = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    var transitionDuration = parseInt(section.dataset.transition, 10) || 600;
    // Auto-rotate is on unless the setting explicitly turned it off. When off,
    // the slideshow only advances via dots or swipe.
    var autoplayEnabled    = section.dataset.autoplay !== 'false';
    var totalSlides        = slides.length;
    var currentIndex       = 0;
    var timer              = null;
    var isTransitioning    = false;
    var reducedMotion      = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    section.style.setProperty('--jc-autoplay-duration', autoplaySpeed + 'ms');
    section.setAttribute('data-jc-autoplay', (reducedMotion || !autoplayEnabled) ? 'false' : 'true');
    section.setAttribute('data-jc-paused', 'false');

    var pausedByHover = false;
    var pausedByFocus = false;

    /*
      Slide videos ship inside <template> so they are not fetched at page load
      (see the note in joyee-banner-carousel.liquid). Hydrate one when it is
      about to be seen, and only for the breakpoint currently on screen - the
      other one is display:none and would be pure waste.

      Slide 0 is already hydrated by the inline script in the section; the
      template is gone by then, so this call is a no-op for it.
    */
    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function hydrate(idx) {
      var slide = slides[idx];
      if (!slide) return;
      var box = slide.querySelector(mobileQuery.matches ? '.joyee-carousel__media--mobile' : '.joyee-carousel__media--desktop');
      if (!box) box = slide.querySelector('.joyee-carousel__media--desktop, .joyee-carousel__media--mobile');
      if (!box) return;
      var tpl = box.querySelector('template[data-jc-video]');
      if (!tpl) return;
      box.insertBefore(tpl.content.cloneNode(true), tpl);
      tpl.remove();
      var video = box.querySelector('video');
      if (!video) return;
      // Same reason as the inline script in the section: a <video> parsed inside
      // a <template> never ran resource selection, so start it explicitly rather
      // than trusting the autoplay attribute to fire on a cloned element.
      if (video.load) video.load();
      // Autoplay can still be refused (data saver, low power mode). Nothing to
      // do about it, but do not let the rejection surface as an unhandled error.
      if (video.play) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    }

    /*
      Off-screen slides sit at opacity 0, not display:none, so their videos keep
      decoding frames the visitor cannot see - real CPU on a phone that is
      already fighting the app scripts. Only the visible slide plays.
    */
    function syncPlayback() {
      // The current slide's video also pauses while the carousel is off screen or the tab is hidden.
      var live = onScreen !== false && !document.hidden;
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === currentIndex && live) {
          if (video.paused && video.play) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    function restartRing() {
      var dot = dots[currentIndex];
      if (!dot) return;
      var c = dot.querySelector('.joyee-carousel__dot-ring circle');
      if (!c) return;
      c.style.animation = 'none';
      void c.offsetWidth;
      c.style.animation = '';
    }

    function goTo(idx) {
      if (idx === currentIndex || isTransitioning) return;
      isTransitioning = true;
      slides[currentIndex].classList.add('is-seen');
      slides[currentIndex].classList.remove('is-active');
      slides[currentIndex].inert = true;   // hidden slides (opacity 0) stay out of the tab order
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
      currentIndex = ((idx % totalSlides) + totalSlides) % totalSlides;
      hydrate(currentIndex);
      slides[currentIndex].inert = false;
      slides[currentIndex].classList.add('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
      restartRing();
      syncPlayback();
      // Runway for the next slide. Under autoplay its video is warmed shortly
      // before the tick. Without autoplay only its poster is fetched: pulling
      // the next slide's whole video here would compete for bandwidth with the
      // video the visitor just swiped to and make that one start later.
      markNext();
      if (timer) scheduleWarm(); else prefetchPoster((currentIndex + 1) % totalSlides);
      setTimeout(function() { isTransitioning = false; }, transitionDuration);
    }

    function next() { goTo(currentIndex + 1); }
    function setPaused() { section.setAttribute('data-jc-paused', (pausedByHover || pausedByFocus) ? 'true' : 'false'); }
    function start() { if (!autoplayEnabled || reducedMotion || pausedByHover || pausedByFocus || !onScreen || document.hidden) return; stop(); timer = setInterval(function () { if (!section.classList.contains('is-motion-paused')) next(); }, autoplaySpeed); scheduleWarm(); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } if (warmTimer) { clearTimeout(warmTimer); warmTimer = null; } }

    /*
      Next-slide video is warmed WARM_LEAD ms before the autoplay tick, not at
      page load. Hydrating starts a full download (each slide video is ~3MB),
      and doing it up front put slide 1's video in the same bandwidth window
      as the hero image on every phone visit, including visits that scroll
      away within seconds. stop() clears the pending warm, so leaving the
      banner or the tab before the tick downloads nothing.
    */
    var WARM_LEAD = 1500;
    var warmTimer = null;
    // hydrate() starts playback on whatever it inserts, so the warmed slide
    // would decode frames behind the visible one at opacity 0. Settle it.
    function warmNext() { markNext(); hydrate((currentIndex + 1) % totalSlides); syncPlayback(); }
    // Lets lazysizes load the next slide's image (the CSS keeps slides not seen yet display:none).
    function markNext() { slides[(currentIndex + 1) % totalSlides].classList.add('is-seen'); }

    // Same URL the <video poster> will ask for, so it is a cache hit later.
    function prefetchPoster(idx) {
      var slide = slides[idx];
      if (!slide) return;
      var box = slide.querySelector(mobileQuery.matches ? '.joyee-carousel__media--mobile' : '.joyee-carousel__media--desktop');
      var tpl = box && box.querySelector('template[data-jc-video]');
      var video = tpl && tpl.content.querySelector('video');
      var url = video && video.getAttribute('poster');
      if (url) { var img = new Image(); img.src = url; }
    }
    function scheduleWarm() {
      if (warmTimer) clearTimeout(warmTimer);
      warmTimer = setTimeout(function () { warmTimer = null; warmNext(); }, Math.max(0, autoplaySpeed - WARM_LEAD));
    }

    /*
      Autoplay must not run while nobody is looking at it.

      goTo() does two things: it advances the slide AND it pre-hydrates the next
      one. Hydrating inserts the <video> and starts the download. So an autoplay
      timer that keeps ticking after the visitor has scrolled past the banner
      will walk the whole carousel on its own and pull down every video anyway -
      which is exactly what shipping them inside <template> was meant to avoid.
      A backgrounded tab is the same story.

      Two gates, both cheap: the section's own visibility, and the tab's.
      No IntersectionObserver (very old browser) means onScreen stays true and
      the behaviour falls back to what it was before.
    */
    var onScreen = true;
    if ('IntersectionObserver' in window) {
      onScreen = null;   // unknown until the first callback: autoplay waits, the visible video is not paused
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) { start(); } else { stop(); }
        syncPlayback();
      }, { rootMargin: '100px 0px' }).observe(section);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
      syncPlayback();
    });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.index, 10)); start(); });
    });

    var sx = 0, sy = 0;
    track.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) { dx < 0 ? next() : goTo(currentIndex - 1); start(); }
    }, { passive: true });

    section.addEventListener('mouseenter', function() { pausedByHover = true;  setPaused(); stop(); });
    section.addEventListener('mouseleave', function() { pausedByHover = false; setPaused(); start(); });
    section.addEventListener('focusin',    function() { pausedByFocus = true;  setPaused(); stop(); });
    section.addEventListener('focusout',   function() { pausedByFocus = false; setPaused(); start(); });

    // Slide 1 is no longer hydrated here; start() schedules it ahead of the
    // first autoplay tick (see scheduleWarm). syncPlayback stays so whatever is
    // already in the DOM matches what is on screen.
    syncPlayback();

    /*
      With autoplay off slide 1's video only starts when
      the visitor swipes, and its poster used to arrive together with it, so
      the box sat blank for a moment before the still frame and then the video
      showed up. Fetch just the poster once the page has finished loading: a
      swipe then shows the still frame at once while the video streams in.
      One image, after load, instead of the whole video during it.
    */
    // Whichever comes first: a second after load, or 5s in. With this many app
    // scripts, load can land long after a visitor has already swiped.
    var posterWarmed = false;
    var warmPoster = function () { if (posterWarmed) return; posterWarmed = true; markNext(); prefetchPoster((currentIndex + 1) % totalSlides); };
    setTimeout(warmPoster, 5000);
    if (document.readyState === 'complete') setTimeout(warmPoster, 1000);
    else window.addEventListener('load', function () { setTimeout(warmPoster, 1000); }, { once: true });

    // A breakpoint change (rotation, desktop resize) swaps which container is
    // visible, so the newly visible one may still be holding its template.
    var onBreakpointChange = function () { hydrate(currentIndex); syncPlayback(); };
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpointChange);
    else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpointChange);

    start();
  });
})();